import React, { useState } from 'react';
import { Link, useNavigate, Routes, Route } from 'react-router-dom';
import { Container, Nav, Navbar, Button } from 'react-bootstrap';
import { List } from 'react-bootstrap-icons';
import authService from '../services/authService';
import DashboardPage from '../pages/DashboardPage';
import './AdminLayout.css';
import useTokenMonitor from '../hooks/useTokenMonitor';
import ExhibitionsManagePage from '../pages/ExhibitionsManagePage';
import CountryExhibitionsPage from '../pages/CountryExhibitionsPage';
import ExhibitionPhotosPage from '../pages/ExhibitionPhotosPage';
import ContactSettingsPage from '../pages/ContactSettingsPage';
import ApplicationsManagePage from '../pages/ApplicationsManagePage';

const AdminLayout = () => {
  useTokenMonitor(); 
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(false);

  const handleLogout = () => {
    authService.logout();
    navigate('/admin/login');
  };

  return (
    <div className="d-flex">
      {/* Sidebar */}
      <div className={`bg-dark text-white admin-sidebar ${showSidebar ? 'show' : ''}`}>
        <div className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4 className="mb-0">Admin Panel</h4>
            <Button variant="link" className="text-white d-md-none p-0" onClick={() => setShowSidebar(false)}>
              ×
            </Button>
          </div>
          <Nav className="flex-column" style={{backgroundColor: '#ffffff !important'}}>
            <Nav.Link as={Link} to="/admin/dashboard" className="text-white" onClick={() => setShowSidebar(false)}>
              Dashboard
            </Nav.Link>
            <Nav.Link as={Link} to="/admin/exhibitions" className="text-white" onClick={() => setShowSidebar(false)}>
              Manage Exhibitions
            </Nav.Link>
            <Nav.Link as={Link} to="/admin/photos" className="text-white" onClick={() => setShowSidebar(false)}>
              Photo Gallery
            </Nav.Link>
            <Nav.Link as={Link} to="/admin/contact-settings" className="text-white" onClick={() => setShowSidebar(false)}>
              Contact Settings
            </Nav.Link>
            <Nav.Link as={Link} to="/admin/applications">
              <i className="bi bi-person-lines-fill"></i> Job Applications
            </Nav.Link>
          </Nav>
        </div>
      </div>

      {/* Main Content */}
      <div className={`flex-grow-1 admin-content ${showSidebar ? 'show' : ''}`}>
        <Navbar className="shadow-sm navbar-bg">
          <Container fluid>
            <Button 
              variant="outline-dark" 
              className="d-md-none"
              onClick={() => setShowSidebar(!showSidebar)}
            >
              <List size={24} />
            </Button>
            <Button variant="danger" onClick={handleLogout}>
              Logout
            </Button>
          </Container>
        </Navbar>

        <Container fluid className="p-4 bg-light" style={{ minHeight: 'calc(100vh - 56px)' }}>
          <Routes>
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="exhibitions" element={<ExhibitionsManagePage />} />
            <Route path="exhibitions/country/:countryId" element={<CountryExhibitionsPage />} />
            <Route path="exhibitions/photos/:exhibitionId" element={<ExhibitionPhotosPage />} />
            <Route path="contact-settings" element={<ContactSettingsPage />} />
            <Route path="applications" element={<ApplicationsManagePage />} />
          </Routes>
        </Container>
      </div>

      {/* Backdrop */}
      {showSidebar && (
        <div 
          className="d-md-none" 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 999
          }}
          onClick={() => setShowSidebar(false)}
        />
      )}
    </div>
  );
};

export default AdminLayout;